import { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";


const CheckTestsPage = () => {

  const { getCheckTests } = useContext(AdminContext);
  const [tests, setTests] = useState(null);
  const [category, setCategory] = useState(null);
  const [error, setError] = useState();
  


  useEffect(() => {
    getCheckTests().then((res) => {
      if (res.status === 200) {
        setTests(res.data.tests);
        document.title = 'Тест "' + res.data.category.category + '"'
        setCategory(res.data.category.category);
      } else {
        setError(res.response.data.message);
      }
    });

  }, []);

  const cutString = (str) => {
    return (str.length > 90 ? (str.substr(0, 90) +'...') : str)
  }

  return (
    <div className="container">
      <div className="admin__retake">
       
        <ButtonBack userUrl="/admin"/>
        <div className="admin__retake__title">Редактор вопросов</div>

        {!category && !tests && !error ? (
          <div style={{ position: "relative", minHeight: 120 }}>
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          </div>
        ) : error ? (
          <p style={{ color: "crimson", fontSize: 30 }}>{error}</p>
        ) : (
          <>
            <div className="admin__retake__title">Категория: {category}</div>

            {!tests.length ? (
              <p style={{ color: "crimson", fontSize: 30 }}>Здесь пока пусто</p>
            ) : (
              <table className="table table__permit">
                <thead>
                  <tr>
                    <th width="75%">Вопрос</th>
                    <th>Действие</th>
                  </tr>
                </thead>
                <tbody>
                  {tests.map((test, id) => (
                    <tr className="search__item" style={{padding: 5}} key={id}>
                    <td style={{ fontSize: 18 }}>
                      <b>{id+1}) </b>{cutString(test.question)}
                    </td>
                    <td style={{ textAlign: "center",  }}>
                      <Link
                        to={"/admin/edit_test/"+test.id}
                        className="btn"
                        style={{ color: "darkcyan", padding: 2 }}
                      >
                        Редактировать
                      </Link>
                    </td>
                  </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default CheckTestsPage;
